document.addEventListener("product:variant-change", function (evt) {
  if (typeof FabrikatorPreOrder === 'undefined') {
    return;
  }

  if (!window.FabrikatorPreOrderInstance) {
    return
  }

  const formControl = window.FabrikatorPreOrderInstance.findFormControl(window.FabrikatorPreOrderInstance.addToCartButton);
  if (!formControl) {
    return;
  }

  window.FabrikatorPreOrderInstance.variantMetafieldExists(formControl, evt.detail.variant.id);
});